"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROGRAM_MISSING_AFTER_MS = void 0;
exports.SignDocumentsModal = SignDocumentsModal;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SigningApi_1 = require("./SigningApi");
const GraphicPlacePicker_1 = require("./GraphicPlacePicker");
const signingTexts_1 = require("./signingTexts");
const UploadSignedPanel_1 = require("./UploadSignedPanel");
/** Po tylu sekundach bez reakcji programu zakładamy, że programu nie ma na tym komputerze. */
exports.PROGRAM_MISSING_AFTER_MS = 20000;
/** Jak często pytamy serwer o stan zlecenia. */
const POLL_MS = 1500;
const fileKey = (file) => file.kind === "LETTER_DOC" ? "LETTER_DOC" : `F:${file.gdFileId}`;
function describeFormat(file) {
    if (file.mimeType === "application/pdf")
        return "PDF";
    if (file.mimeType === "application/vnd.google-apps.document")
        return "Dokument Google — zamienię go na PDF";
    if (file.mimeType === "application/vnd.google-apps.spreadsheet")
        return "Arkusz Google — zamienię go na PDF";
    return file.mimeType;
}
/** Otwiera program przez własny protokół, nie opuszczając strony (kliknięcie niewidocznego linku). */
function launchProtocol(href) {
    const link = document.createElement("a");
    link.href = href;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
function formatClock(iso) {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime()))
        return "";
    return date.toLocaleTimeString("pl-PL", { hour: "2-digit", minute: "2-digit" });
}
const STEPS = ["Wybór plików", "Program ENVI Podpis", "Kontrola i PIN", "Zapis na Dysku"];
function Stepper({ current }) {
    return (react_1.default.createElement("ol", { className: "list-unstyled d-flex flex-wrap mb-3 p-0", style: { gap: "6px 18px", fontSize: ".85rem" }, "aria-label": "Post\u0119p podpisywania" }, STEPS.map((label, index) => {
        const done = index < current;
        const active = index === current;
        return (react_1.default.createElement("li", { key: label, "aria-current": active ? "step" : undefined, className: active ? "fw-bold text-success" : done ? "text-success" : "text-muted" },
            react_1.default.createElement("span", { className: "d-inline-flex align-items-center justify-content-center me-1", style: {
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    fontSize: ".72rem",
                    border: "1px solid currentColor",
                    backgroundColor: done || active ? "currentColor" : "transparent",
                } },
                react_1.default.createElement("span", { style: { color: done || active ? "#fff" : "inherit" } }, done ? "✓" : index + 1)),
            label));
    })));
}
function Waiting({ title, children }) {
    return (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info", className: "d-flex align-items-start", style: { gap: "12px" }, role: "status" },
        react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", role: "status", "aria-hidden": "true", className: "mt-1" }),
        react_1.default.createElement("div", null,
            react_1.default.createElement("strong", null, title),
            children && react_1.default.createElement("div", { className: "mt-1" }, children))));
}
/**
 * Okno „PDF z podpisem”: wybór plików → program ENVI Podpis → kontrola i PIN → zapis na Dysku.
 * W każdym stanie okno mówi, co się właśnie dzieje i co użytkownik ma teraz zrobić.
 */
function SignDocumentsModalContent({ source, onHide, onSigned, onUploaded, startInUpload }) {
    const [phase, setPhase] = (0, react_1.useState)(startInUpload ? "upload" : "loading");
    const [signable, setSignable] = (0, react_1.useState)(null);
    const [selection, setSelection] = (0, react_1.useState)({});
    const [places, setPlaces] = (0, react_1.useState)({});
    const [pickerFile, setPickerFile] = (0, react_1.useState)(null);
    const placeRequests = (0, react_1.useRef)({});
    const [loadError, setLoadError] = (0, react_1.useState)(null);
    const [startError, setStartError] = (0, react_1.useState)(null);
    const [existing, setExisting] = (0, react_1.useState)([]);
    const [job, setJob] = (0, react_1.useState)(null);
    const [state, setState] = (0, react_1.useState)(null);
    const [launchedAt, setLaunchedAt] = (0, react_1.useState)(0);
    const [now, setNow] = (0, react_1.useState)(Date.now());
    const [pollProblem, setPollProblem] = (0, react_1.useState)(false);
    const [actionError, setActionError] = (0, react_1.useState)(null);
    const [cancelling, setCancelling] = (0, react_1.useState)(false);
    const reportedDone = (0, react_1.useRef)(false);
    const mounted = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
            placeRequests.current = {};
        };
    }, []);
    // ------------------------------------------------------------------ 1. lista plików
    const loadFiles = (0, react_1.useCallback)(async () => {
        placeRequests.current = {};
        setPlaces({});
        setPickerFile(null);
        setPhase("loading");
        setLoadError(null);
        try {
            const result = await source.listFiles();
            if (!mounted.current)
                return;
            setSignable(result);
            const initial = {};
            for (const file of result.files)
                initial[fileKey(file)] = { sign: source.preselectFiles !== false && !file.signedNameHint, graphic: source.graphicPlace ? false : file.withGraphic };
            setSelection(initial);
            setPhase("select");
        }
        catch (error) {
            if (!mounted.current)
                return;
            setLoadError(error instanceof Error ? error.message : "Nie udało się wczytać listy plików.");
            setPhase("loadError");
        }
        // Ostrzeżenie o już istniejących podpisach jest dodatkiem: jego błąd nie blokuje podpisywania.
        try {
            const signatures = await source.listSignatures();
            if (mounted.current)
                setExisting(signatures);
        }
        catch {
            if (mounted.current)
                setExisting([]);
        }
    }, [source]);
    (0, react_1.useEffect)(() => {
        if (!startInUpload)
            loadFiles();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    function clearPlace(file) {
        const key = fileKey(file);
        delete placeRequests.current[key];
        setPlaces((prev) => {
            const next = { ...prev };
            delete next[key];
            return next;
        });
    }
    async function locatePlace(file) {
        if (!source.graphicPlace)
            return;
        const key = fileKey(file);
        const request = Symbol();
        placeRequests.current[key] = request;
        setPlaces((prev) => ({ ...prev, [key]: { status: "searching" } }));
        try {
            const search = await source.graphicPlace.locate(file);
            if (!mounted.current || placeRequests.current[key] !== request)
                return;
            if (!search.pages.some((page) => page.placeable)) {
                setSelection((prev) => ({ ...prev, [key]: { ...prev[key], graphic: false } }));
                setPlaces((prev) => ({ ...prev, [key]: { status: "unavailable" } }));
                return;
            }
            const candidate = search.candidates.length === 1 ? search.candidates[0] : undefined;
            setPlaces((prev) => ({ ...prev, [key]: {
                    status: "ready", search,
                    placement: candidate ? { page: candidate.page, rect: candidate.rect } : undefined,
                    label: candidate?.label,
                } }));
        }
        catch (error) {
            if (!mounted.current || placeRequests.current[key] !== request)
                return;
            setPlaces((prev) => ({ ...prev, [key]: {
                    status: "error", message: error instanceof Error ? error.message : "Sprawdź połączenie z PS i spróbuj ponownie.",
                } }));
        }
    }
    const loadPickerPage = (0, react_1.useCallback)((page) => source.graphicPlace.pageImage(pickerFile, page), [source, pickerFile]);
    // ------------------------------------------------------------------ 2. zakładanie zlecenia
    const selectedFiles = (signable?.files ?? []).filter((file) => selection[fileKey(file)]?.sign);
    const missingPlaces = source.graphicPlace ? selectedFiles.filter((file) => {
        const key = fileKey(file);
        const place = places[key];
        return selection[key]?.graphic && (place?.status !== "ready" || !place.placement);
    }) : [];
    async function startJob() {
        if (!signable || selectedFiles.length === 0 || missingPlaces.length > 0)
            return;
        setStartError(null);
        setActionError(null);
        setPhase("starting");
        // Poprzednie zlecenie (jeszcze aktywne) zamykamy, żeby nie wisiał ważny token.
        await cancelSilently();
        try {
            const created = await source.createJob(selectedFiles.map((file) => {
                const key = fileKey(file);
                const withGraphic = !source.graphicPlace && file.graphicLocked ? true : !!selection[key]?.graphic;
                const place = places[key];
                return {
                    kind: file.kind,
                    gdFileId: file.kind === "DRIVE_FILE" ? file.gdFileId : undefined,
                    withGraphic,
                    ...(source.graphicPlace && withGraphic && place?.status === "ready" ? { placement: place.placement } : {}),
                };
            }));
            if (!mounted.current)
                return;
            reportedDone.current = false;
            setJob(created);
            setState(null);
            setPollProblem(false);
            setLaunchedAt(Date.now());
            setNow(Date.now());
            setPhase("job");
            launchProtocol(created.protocolUrl);
        }
        catch (error) {
            if (!mounted.current)
                return;
            setStartError(error instanceof Error ? error.message : "Nie udało się założyć zlecenia podpisu.");
            setPhase("select");
        }
    }
    async function cancelSilently() {
        if (job && (!state || !SigningApi_1.FINISHED_JOB_STATUSES.includes(state.status))) {
            try {
                await SigningApi_1.SigningApi.cancelJob(job.jobId, signingTexts_1.CANCEL_REASON_FROM_PS);
            }
            catch {
                // zlecenie i tak wygasa samo po kilku minutach
            }
        }
        setJob(null);
        setState(null);
    }
    // ------------------------------------------------------------------ 3-6. odpytywanie zlecenia
    const jobId = job?.jobId;
    (0, react_1.useEffect)(() => {
        if (jobId === undefined)
            return;
        let stopped = false;
        let timer;
        const tick = async () => {
            let finished = false;
            try {
                const next = await SigningApi_1.SigningApi.getJobState(jobId);
                if (stopped)
                    return;
                setState(next);
                setPollProblem(false);
                finished = SigningApi_1.FINISHED_JOB_STATUSES.includes(next.status);
            }
            catch {
                if (stopped)
                    return;
                // Chwilowy brak łączności nie kończy zlecenia: pokazujemy uwagę i pytamy dalej.
                setPollProblem(true);
            }
            if (!finished && !stopped)
                timer = setTimeout(tick, POLL_MS);
        };
        tick();
        return () => {
            stopped = true;
            if (timer)
                clearTimeout(timer);
        };
    }, [jobId]);
    // Zegar odświeżający odliczanie („nie widzę programu”, godzina wygaśnięcia).
    const jobActive = !!job && (!state || !SigningApi_1.FINISHED_JOB_STATUSES.includes(state.status));
    (0, react_1.useEffect)(() => {
        if (!jobActive)
            return;
        const interval = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(interval);
    }, [jobActive]);
    (0, react_1.useEffect)(() => {
        if (state?.status === "done" && !reportedDone.current) {
            reportedDone.current = true;
            source.onChanged();
            onSigned?.(state.files.length);
        }
    }, [state, source, onSigned]);
    async function cancelFromPs() {
        if (!job)
            return;
        setCancelling(true);
        setActionError(null);
        try {
            await SigningApi_1.SigningApi.cancelJob(job.jobId, signingTexts_1.CANCEL_REASON_FROM_PS);
            if (!mounted.current)
                return;
            setState({
                jobId: job.jobId,
                status: "cancelled",
                expiresAt: job.expiresAt,
                failureMessage: null,
                cancelReason: signingTexts_1.CANCEL_REASON_FROM_PS,
                signer: null,
                certChangedWarning: false,
                files: [],
            });
        }
        catch (error) {
            if (!mounted.current)
                return;
            setActionError(error instanceof Error
                ? `${error.message} Poczekaj chwilę i sprawdź, co pokazuje to okno.`
                : "Nie udało się anulować zlecenia.");
        }
        finally {
            if (mounted.current)
                setCancelling(false);
        }
    }
    /** „Wgraj podpisany” zamyka aktywne zlecenie, żeby nie podpisać dwa razy (programem i ręcznie). */
    async function openUpload() {
        await cancelSilently();
        setActionError(null);
        setPhase("upload");
    }
    function backToSelection() {
        setJob(null);
        setState(null);
        setActionError(null);
        setStartError(null);
        setPhase("select");
    }
    // ------------------------------------------------------------------ widoki
    const status = state?.status ?? (job ? "created" : undefined);
    const programMissing = status === "created" && now - launchedAt >= exports.PROGRAM_MISSING_AFTER_MS;
    const locked = phase === "starting" || (phase === "job" && jobActive);
    const closable = !locked && status !== "finalizing";
    // Po zakończeniu bez podpisu (anulowane, wygasłe, nieudane) „postęp” nic już nie mówi — chowamy go.
    const jobStopped = phase === "job" && (status === "cancelled" || status === "expired" || status === "failed");
    const currentStep = phase !== "job"
        ? 0
        : status === "created" || status === "preparing"
            ? 1
            : status === "prepared"
                ? 2
                : 3;
    const texts = source.texts;
    const title = `PDF z podpisem — ${texts.subject}`;
    function renderPlace(file) {
        const place = places[fileKey(file)];
        if (!place)
            return null;
        if (place.status === "searching")
            return (react_1.default.createElement("div", { className: "small text-muted mt-1", role: "status" },
                react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", "aria-hidden": "true", className: "me-2" }),
                "Szukam w dokumencie miejsca na podpis\u2026"));
        if (place.status === "unavailable")
            return (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "small py-2 mt-2 mb-0" }, "W tym pliku nie da si\u0119 ustawi\u0107 grafiki (strony maj\u0105 nietypowy uk\u0142ad, np. s\u0105 obr\u00F3cone). Podpisz go bez grafiki."));
        if (place.status === "error")
            return (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "small py-2 mt-2 mb-0" },
                "Nie uda\u0142o si\u0119 sprawdzi\u0107 dokumentu: ",
                place.message,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "link", size: "sm", className: "p-0", onClick: () => locatePlace(file) }, "Spr\u00F3buj ponownie"))));
        const chooseButton = (react_1.default.createElement(react_bootstrap_1.Button, { variant: "link", size: "sm", className: "p-0", onClick: () => { setPickerFile(file); setPhase("picker"); } }, place.placement ? "Pokaż lub zmień miejsce" : "Wskaż miejsce"));
        if (place.placement)
            return (react_1.default.createElement("div", { className: "small text-muted mt-1", style: { overflowWrap: "anywhere" } },
                react_1.default.createElement("div", null, place.label !== undefined
                    ? `Grafika stanie na stronie ${place.placement.page}, przy napisie „${place.label}”.`
                    : `Grafika stanie na stronie ${place.placement.page}, w miejscu wskazanym przez Ciebie.`),
                chooseButton));
        const count = (0, signingTexts_1.pluralPlaces)(place.search.candidates.length);
        return (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "small py-2 mt-2 mb-0" },
            react_1.default.createElement("div", null, place.search.candidates.length === 0
                ? "Nie znalazłem w dokumencie miejsca na podpis. Wskaż, gdzie ma stanąć grafika."
                : `W dokumencie ${count.endsWith("miejsca") ? "są" : "jest"} ${count} na podpis. Wskaż właściwe.`),
            chooseButton));
    }
    function renderSelect() {
        if (!signable)
            return null;
        const letterFile = signable.files.find((file) => file.kind === "LETTER_DOC");
        const attachments = signable.files.filter((file) => file.kind !== "LETTER_DOC");
        const rows = letterFile ? [letterFile, ...attachments] : attachments;
        function setSign(file, sign) {
            setSelection((prev) => ({ ...prev, [fileKey(file)]: { ...prev[fileKey(file)], sign } }));
            if (!sign)
                clearPlace(file);
            else if (selection[fileKey(file)]?.graphic)
                locatePlace(file);
        }
        function setGraphic(file, graphic) {
            setSelection((prev) => ({ ...prev, [fileKey(file)]: { ...prev[fileKey(file)], graphic } }));
            if (graphic)
                locatePlace(file);
            else
                clearPlace(file);
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", { className: "mb-1" },
                react_1.default.createElement("strong", null, "Zaznacz pliki, kt\u00F3re maj\u0105 zosta\u0107 podpisane kart\u0105 kwalifikowan\u0105.")),
            react_1.default.createElement("p", { className: "text-muted small" },
                "Podpisane kopie zapisz\u0119 ",
                texts.inFolder,
                " na Dysku Google jako \u201Enazwa_pdp.pdf\u201D. Orygina\u0142y zostaj\u0105 bez zmian. Po klikni\u0119ciu \u201EPodpisz\u201D otworzy si\u0119 program ENVI Podpis na Twoim komputerze: tam wybierzesz certyfikat i wpiszesz PIN."),
            existing.length > 0 && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "py-2 small" },
                texts.thisHasAlready,
                " ",
                (0, signingTexts_1.pluralSignedFiles)(existing.length),
                " (ostatni: \u201E",
                existing[0].signedName,
                "\u201D,",
                " ",
                existing[0].signerName,
                "). Kolejny podpis doda nowy plik z dat\u0105 w nazwie \u2014 niczego nie nadpisze.")),
            startError && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", className: "py-2" },
                react_1.default.createElement("strong", null, "Nie uda\u0142o si\u0119 rozpocz\u0105\u0107 podpisywania."),
                react_1.default.createElement("br", null),
                startError,
                react_1.default.createElement("div", { className: "mt-2" },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-danger", onClick: loadFiles }, "Od\u015Bwie\u017C list\u0119 plik\u00F3w")))),
            react_1.default.createElement("div", { className: "mb-3" },
                rows.map((file) => {
                    const key = fileKey(file);
                    const choice = selection[key] ?? { sign: source.preselectFiles !== false && !file.signedNameHint, graphic: file.withGraphic };
                    const isLetter = file.kind === "LETTER_DOC";
                    return (react_1.default.createElement("div", { key: key, className: "border rounded p-2 mb-2", style: { backgroundColor: choice.sign ? "#f7fbf8" : "transparent" } },
                        react_1.default.createElement("div", { className: "d-flex flex-wrap align-items-center justify-content-between", style: { gap: "8px 16px" } },
                            react_1.default.createElement("div", { style: { minWidth: 0, flex: "1 1 260px", wordBreak: "break-word" } },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: isLetter ? free_solid_svg_icons_1.faFileLines : free_solid_svg_icons_1.faFilePdf, className: isLetter ? "text-success me-2" : "text-danger me-2" }),
                                react_1.default.createElement("strong", null, file.name),
                                file.signedNameHint && react_1.default.createElement("span", { className: "small text-muted ms-2" }, "ma ju\u017C podpis - dodamy kolejny"),
                                isLetter && texts.mainDocBadge && (react_1.default.createElement(react_bootstrap_1.Badge, { bg: "success", className: "ms-2" }, texts.mainDocBadge)),
                                react_1.default.createElement("div", { className: "small text-muted" }, describeFormat(file))),
                            react_1.default.createElement("div", { className: "d-flex", style: { gap: "18px" } },
                                react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "checkbox", id: `sign-${key}`, label: "podpisz", checked: choice.sign, onChange: (event) => setSign(file, event.target.checked) }),
                                react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "checkbox", id: `graphic-${key}`, label: "grafika", checked: !source.graphicPlace && file.graphicLocked ? true : choice.graphic, disabled: (!source.graphicPlace && file.graphicLocked) || !choice.sign, onChange: (event) => setGraphic(file, event.target.checked) }))),
                        source.graphicPlace ? (choice.sign && renderPlace(file)) : file.graphicLocked ? (react_1.default.createElement("div", { className: "small text-muted mt-1" }, texts.lockedGraphicNote)) : (choice.sign &&
                            choice.graphic && (react_1.default.createElement("div", { className: "small text-muted mt-1" }, "Grafika trafi do prawego dolnego rogu ostatniej strony.")))));
                }),
                !letterFile && texts.noMainDocNote && (react_1.default.createElement("div", { className: "small text-muted" }, texts.noMainDocNote))),
            signable.notSignable.length > 0 && (react_1.default.createElement("div", { className: "mb-3" },
                react_1.default.createElement("div", { className: "small fw-semibold text-muted mb-1" }, "Tych plik\u00F3w nie podpiszemy:"),
                signable.notSignable.map((file) => (react_1.default.createElement("div", { key: file.gdFileId, className: "border rounded p-2 mb-1 small text-muted", style: { backgroundColor: "#f3f4f4", wordBreak: "break-word" } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFilePdf, className: "me-2", style: { opacity: 0.45 } }),
                    react_1.default.createElement("span", null, file.name),
                    react_1.default.createElement("div", null, file.reason)))))),
            rows.length === 0 ? (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info", className: "py-2" },
                "Nie ma plik\u00F3w, kt\u00F3re mo\u017Cna podpisa\u0107 ",
                texts.inFolder,
                " na Dysku Google. W\u0142\u00F3\u017C tam pliki PDF i od\u015Bwie\u017C list\u0119.",
                react_1.default.createElement("div", { className: "mt-2" },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-secondary", onClick: loadFiles }, "Od\u015Bwie\u017C list\u0119 plik\u00F3w")))) : (selectedFiles.length === 0 && (react_1.default.createElement("div", { className: "small text-danger" }, "Zaznacz co najmniej jeden plik do podpisu."))),
            missingPlaces.length > 0 && (react_1.default.createElement("div", { className: "small text-muted", style: { overflowWrap: "anywhere" }, role: "status" },
                places[fileKey(missingPlaces[0])]?.status === "searching"
                    ? `Sprawdzam plik „${missingPlaces[0].name}”…`
                    : places[fileKey(missingPlaces[0])]?.status === "error"
                        ? "Spróbuj ponownie albo sprawdź komunikat powyżej."
                        : `Wskaż miejsce grafiki w pliku „${missingPlaces[0].name}” albo wyłącz dla niego grafikę.`,
                missingPlaces.length > 1 && ` Pozostałe pliki bez miejsca: ${missingPlaces.length - 1}.`))));
    }
    function renderJob() {
        if (!job)
            return null;
        const files = state?.files ?? [];
        const expiresAt = state?.expiresAt ?? job.expiresAt;
        const problem = pollProblem && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "py-2 small" }, "Chwilowo nie mam \u0142\u0105czno\u015Bci z PS. Pr\u00F3buj\u0119 dalej \u2014 nic nie klikaj. Podpisywanie w programie trwa niezale\u017Cnie od tego okna."));
        if (status === "created") {
            if (programMissing) {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    problem,
                    react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning" },
                        react_1.default.createElement("div", { className: "d-flex align-items-start", style: { gap: "10px" } },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTriangleExclamation, className: "mt-1" }),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("strong", null, "Nie widz\u0119 programu ENVI Podpis."),
                                react_1.default.createElement("div", { className: "mt-1" }, "Je\u015Bli to Tw\u00F3j pierwszy podpis na tym komputerze, trzeba zainstalowa\u0107 program (jeden raz): pobierz go, kliknij dwa razy, wr\u00F3\u0107 tu i kliknij \u201EPodpisz\u201D.")))),
                    react_1.default.createElement("div", { className: "d-flex flex-wrap mb-3", style: { gap: "10px" } },
                        react_1.default.createElement("a", { className: "btn btn-primary", href: SigningApi_1.SigningApi.programDownloadUrl() },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faDownload, className: "me-2" }),
                            "Pobierz program ENVI Podpis"),
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-success", onClick: startJob }, "Mam ju\u017C program \u2014 spr\u00F3buj ponownie"),
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", onClick: openUpload }, "Wgraj podpisany")),
                    react_1.default.createElement("ul", { className: "small text-muted ps-3" },
                        react_1.default.createElement("li", null, "Program ju\u017C si\u0119 otworzy\u0142 i co\u015B pokaza\u0142? Doko\u0144cz w nim \u2014 to okno od\u015Bwie\u017Cy si\u0119 samo. Program mo\u017Ce te\u017C prosi\u0107 o nowsz\u0105 wersj\u0119: wtedy pobierz j\u0105 przyciskiem wy\u017Cej."),
                        react_1.default.createElement("li", null,
                            "Przegl\u0105darka mog\u0142a zapyta\u0107 \u201Eotworzy\u0107 ENVI Podpis?\u201D. Zezw\u00F3l (mo\u017Cesz zaznaczy\u0107 \u201Ezawsze\u201D). Nie ma okna pytania? ",
                            react_1.default.createElement("a", { href: job.protocolUrl }, "Otw\u00F3rz program r\u0119cznie"),
                            "."),
                        react_1.default.createElement("li", null, "Podpisujesz kart\u0105 i nie mo\u017Cesz zainstalowa\u0107 programu? U\u017Cyj \u201EWgraj podpisany\u201D: podpiszesz plik w innym programie, a tutaj tylko go wgrasz.")),
                    react_1.default.createElement("div", { className: "small text-muted" },
                        "Nadal czekam na program. Zlecenie jest wa\u017Cne do ",
                        formatClock(expiresAt),
                        ".")));
            }
            return (react_1.default.createElement(react_1.default.Fragment, null,
                problem,
                react_1.default.createElement(Waiting, { title: "Otwieram program ENVI Podpis\u2026" }, "Je\u015Bli przegl\u0105darka zapyta \u201Eotworzy\u0107 ENVI Podpis?\u201D, pozw\u00F3l otworzy\u0107 (mo\u017Cesz zaznaczy\u0107 \u201Ezawsze\u201D). Potem w programie wybierz certyfikat i post\u0119puj wed\u0142ug jego instrukcji."),
                react_1.default.createElement("div", { className: "small text-muted" },
                    "Okno programu si\u0119 nie pojawi\u0142o?",
                    " ",
                    react_1.default.createElement("a", { href: job.protocolUrl }, "Otw\u00F3rz program jeszcze raz"),
                    ". Zlecenie jest wa\u017Cne do",
                    " ",
                    formatClock(expiresAt),
                    ".")));
        }
        if (status === "preparing") {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                problem,
                react_1.default.createElement(Waiting, { title: "Program przes\u0142a\u0142 certyfikat. Przygotowuj\u0119 pliki do podpisu\u2026" }, "Pobieram pliki z Dysku Google i dodaj\u0119 grafik\u0119 podpisu. To trwa zwykle kilka sekund \u2014 nic nie klikaj.")));
        }
        if (status === "prepared" || status === "finalizing") {
            const finalizing = status === "finalizing";
            return (react_1.default.createElement(react_1.default.Fragment, null,
                problem,
                finalizing ? (react_1.default.createElement(Waiting, { title: "Zapisuj\u0119 podpisane pliki na Dysku\u2026" }, "PIN zosta\u0142 przyj\u0119ty. Nie zamykaj tego okna, to potrwa chwil\u0119.")) : (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info", role: "status" },
                    react_1.default.createElement("strong", null,
                        "Pliki s\u0105 gotowe do podpisu",
                        state?.signer ? ` (podpisze: ${state.signer.name})` : "",
                        "."),
                    react_1.default.createElement("div", { className: "mt-1" },
                        "Obejrzyj je, por\u00F3wnaj kod kontrolny z kodem w programie ENVI Podpis, a potem wpisz PIN w programie. Je\u015Bli co\u015B si\u0119 nie zgadza \u2014 anuluj. Czekam na Twoje potwierdzenie w programie (zlecenie wa\u017Cne do ",
                        formatClock(expiresAt),
                        ")."))),
                state?.certChangedWarning && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "py-2 small" },
                    react_1.default.createElement("strong", null, "Uwaga:"),
                    " ta karta ma inny certyfikat ni\u017C ostatnio u\u017Cywany do podpisywania w PS. Je\u015Bli wymienia\u0142e\u015B kart\u0119 \u2014 to normalne. Je\u015Bli nie, anuluj i sprawd\u017A, czyj\u0105 kart\u0119 w\u0142o\u017Cono.")),
                files.map((file) => (react_1.default.createElement("div", { key: file.index, className: "border rounded p-3 mb-2", style: { wordBreak: "break-word" } },
                    react_1.default.createElement("div", { className: "d-flex flex-wrap justify-content-between", style: { gap: "8px 16px" } },
                        react_1.default.createElement("div", { style: { flex: "1 1 240px", minWidth: 0 } },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFilePdf, className: "text-danger me-2" }),
                            react_1.default.createElement("strong", null, file.name),
                            react_1.default.createElement("div", { className: "small text-muted" },
                                file.pages ? (0, signingTexts_1.pluralPages)(file.pages) : "",
                                file.withGraphic ? " · z grafiką podpisu" : " · bez grafiki"),
                            file.previewAvailable && (react_1.default.createElement("a", { href: SigningApi_1.SigningApi.previewUrl(job.jobId, file.index), target: "_blank", rel: "noopener noreferrer", className: "small" },
                                "Zobacz gotowy PDF w nowej karcie",
                                " ",
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faArrowUpRightFromSquare })))),
                        file.checkCode && (react_1.default.createElement("div", { className: "text-center", style: { flex: "0 0 auto" } },
                            react_1.default.createElement("div", { className: "small text-muted" }, "kod kontrolny"),
                            react_1.default.createElement("div", { "aria-label": `Kod kontrolny ${(0, signingTexts_1.formatCheckCode)(file.checkCode)}`, style: {
                                    fontFamily: 'ui-monospace, "Cascadia Mono", Consolas, monospace',
                                    fontSize: "1.7rem",
                                    fontWeight: 700,
                                    letterSpacing: ".08em",
                                    lineHeight: 1.1,
                                } }, (0, signingTexts_1.formatCheckCode)(file.checkCode)))))))),
                !finalizing && (react_1.default.createElement("p", { className: "small text-muted mt-2 mb-0" }, "Por\u00F3wnaj kod z kodem w programie ENVI Podpis, potem wpisz PIN w programie."))));
        }
        if (status === "done") {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCircleCheck, className: "me-2" }),
                    react_1.default.createElement("strong", null,
                        "Gotowe. Podpisane pliki s\u0105 ju\u017C ",
                        texts.inFolder,
                        " na Dysku Google."),
                    texts.doneNote && react_1.default.createElement("div", { className: "mt-1" }, texts.doneNote)),
                state?.files.map((file) => (react_1.default.createElement("div", { key: file.index, className: "mb-2", style: { wordBreak: "break-word" } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFilePdf, className: "text-danger me-2" }),
                    file.signedUrl ? (react_1.default.createElement("a", { href: file.signedUrl, target: "_blank", rel: "noopener noreferrer" }, file.signedName ?? file.name)) : (react_1.default.createElement("span", null, file.signedName ?? file.name)))))));
        }
        if (status === "expired") {
            return (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning" },
                react_1.default.createElement("strong", null, "Zlecenie podpisu wygas\u0142o."),
                react_1.default.createElement("div", { className: "mt-1" }, "Jest wa\u017Cne 10 minut od klikni\u0119cia \u201EPodpisz\u201D, a w tym czasie nie doko\u0144czono podpisywania w programie. Nic nie zosta\u0142o podpisane ani zapisane. Kliknij \u201ESpr\u00F3buj ponownie\u201D.")));
        }
        if (status === "failed") {
            return (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" },
                react_1.default.createElement("strong", null, "Podpisywanie si\u0119 nie uda\u0142o."),
                react_1.default.createElement("div", { className: "mt-1" }, state?.failureMessage ?? "Coś poszło nie tak po stronie PS."),
                react_1.default.createElement("div", { className: "mt-1 small" }, "Kliknij \u201ESpr\u00F3buj ponownie\u201D. Je\u015Bli b\u0142\u0105d si\u0119 powtarza, u\u017Cyj \u201EWgraj podpisany\u201D albo zg\u0142o\u015B problem.")));
        }
        // cancelled
        const explanation = (0, signingTexts_1.explainCancelReason)(state?.cancelReason);
        return (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "secondary" },
            react_1.default.createElement("strong", null, "Podpisywanie przerwane."),
            react_1.default.createElement("div", { className: "mt-1" }, explanation.message),
            explanation.suggestUpload && (react_1.default.createElement("div", { className: "mt-1 small" }, "U\u017Cyj \u201EWgraj podpisany\u201D, \u017Ceby doko\u0144czy\u0107 spraw\u0119 bez karty w programie."))));
    }
    function renderBody() {
        if (phase === "loading" || phase === "starting") {
            return (react_1.default.createElement(Waiting, { title: phase === "loading" ? "Wczytuję pliki do podpisu…" : "Zakładam zlecenie podpisu…" }, phase === "loading"
                ? `Sprawdzam, co leży ${texts.inFolder} na Dysku Google. To trwa kilka sekund.`
                : "Za chwilę otworzy się program ENVI Podpis."));
        }
        if (phase === "loadError") {
            return (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" },
                react_1.default.createElement("strong", null, "Nie uda\u0142o si\u0119 wczyta\u0107 plik\u00F3w."),
                react_1.default.createElement("div", { className: "mt-1" }, loadError),
                react_1.default.createElement("div", { className: "mt-1 small" }, "Gdy przyczyna zniknie, kliknij \u201ESpr\u00F3buj ponownie\u201D.")));
        }
        if (phase === "upload") {
            return (react_1.default.createElement(UploadSignedPanel_1.UploadSignedPanel, { source: source, onUploaded: onUploaded }));
        }
        if (phase === "job")
            return renderJob();
        return renderSelect();
    }
    function renderFooter() {
        if (phase === "loading") {
            return react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", onClick: onHide }, "Zamknij");
        }
        if (phase === "starting")
            return null;
        if (phase === "loadError") {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", onClick: onHide }, "Zamknij"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", onClick: loadFiles }, "Spr\u00F3buj ponownie")));
        }
        if (phase === "upload") {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                !startInUpload && (react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-success", onClick: () => (signable ? setPhase("select") : loadFiles()) }, "Wr\u00F3\u0107 do podpisywania w programie")),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", onClick: onHide }, "Zamknij")));
        }
        if (phase === "select") {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", onClick: onHide }, "Zamknij"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-primary", onClick: openUpload }, "Wgraj podpisany"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", disabled: selectedFiles.length === 0 || missingPlaces.length > 0, onClick: startJob },
                    "Podpisz ",
                    selectedFiles.length > 0 ? `(${(0, signingTexts_1.pluralFiles)(selectedFiles.length)})` : "")));
        }
        // job
        if (status === "finalizing") {
            return react_1.default.createElement("span", { className: "text-muted small" }, "Poczekaj, zapisuj\u0119 pliki\u2026");
        }
        if (jobActive) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                actionError && react_1.default.createElement("span", { className: "text-danger small me-auto" }, actionError),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-danger", disabled: cancelling, onClick: cancelFromPs }, cancelling ? "Anuluję…" : "Anuluj podpisywanie")));
        }
        if (status === "done") {
            return (react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", onClick: onHide }, "Zamknij"));
        }
        const explanation = status === "cancelled" ? (0, signingTexts_1.explainCancelReason)(state?.cancelReason) : null;
        const uploadFirst = explanation?.suggestUpload;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", onClick: onHide }, "Zamknij"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", onClick: backToSelection }, "Wr\u00F3\u0107 do wyboru plik\u00F3w"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: uploadFirst ? "success" : "outline-primary", onClick: openUpload }, "Wgraj podpisany"),
            !uploadFirst && (react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", onClick: startJob }, "Spr\u00F3buj ponownie"))));
    }
    const pickerPlace = pickerFile ? places[fileKey(pickerFile)] : undefined;
    return (react_1.default.createElement(react_bootstrap_1.Modal, { size: "lg", show: true, onHide: closable ? onHide : undefined, backdrop: closable ? true : "static", keyboard: closable, enforceFocus: false, scrollable: phase === "picker" },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: closable },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, { as: "h5" }, title)),
        phase === "picker" && pickerFile && pickerPlace?.status === "ready" ? (react_1.default.createElement(GraphicPlacePicker_1.GraphicPlacePicker, { fileName: pickerFile.name, search: pickerPlace.search, initial: pickerPlace.placement, 
            // Bez oznaczonego miejsca zaczynamy od ostatniej strony: tam zwykle jest podpis.
            initialPage: pickerPlace.search.candidates[0]?.page ?? pickerPlace.search.pages.length, loadPage: loadPickerPage, onCancel: () => { setPickerFile(null); setPhase("select"); }, onConfirm: (placement) => {
                const key = fileKey(pickerFile);
                setPlaces((prev) => ({ ...prev, [key]: {
                        ...pickerPlace, placement,
                        label: placement === pickerPlace.placement ? pickerPlace.label : undefined,
                    } }));
                setPickerFile(null);
                setPhase("select");
            } },
            react_1.default.createElement(Stepper, { current: 0 }))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                phase !== "upload" && !jobStopped && react_1.default.createElement(Stepper, { current: currentStep }),
                phase === "upload" && (react_1.default.createElement("h6", { className: "mb-2" }, "Wgraj podpisany \u2014 plik podpisany poza PS")),
                renderBody()),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null, renderFooter())))));
}
/** Okno „PDF z podpisem”. Zawartość montuje się od nowa przy każdym otwarciu (czysty stan). */
function SignDocumentsModal({ show, ...rest }) {
    if (!show)
        return null;
    return react_1.default.createElement(SignDocumentsModalContent, { ...rest });
}
